import { Box, Text } from '@usealloy/component-library';
import styled from 'styled-components';

export const ModalBody = styled(Box)`
  &&& {
    padding-left: var(--cl-space-1);
    /* adding a negative margin to counter the aggressive padding-top set by the Modal */
    margin-top: -20px;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
  }
`;

export const ModalDescription = styled(Text)`
  &&& {
    line-height: 18px;
    color: var(--cl-gray-700);
  }
`;


export const ModalLink = styled.a`
  &&& {
    text-transform: none;
    font-weight: normal;
    text-decoration: underline;
  }
`;
